export enum WizardIdEnum {
    CREATE_ORDER_WIZARD = 'create-order-wizard',
    NAVIGATION_BLOCK = 'navigation-block',
    VIGNETTE_LIST_PRESENTATION = 'vignette-list-presentation',
    GUIDE_PRESENTATION = 'guide-presentation',
    DDM_INDICATIVE = 'ddm-indicative',
    VISIBILITE_STOCKS = 'visibilite-stocks',
}